import React, { useState, useEffect } from 'react';



interface HostedProps {
  email: string;
  business: string;
  loggedIn: boolean;
  token: string;
  setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setBusiness: React.Dispatch<React.SetStateAction<string>>;
  baseUrl: string;
}

const Hosted: React.FC<HostedProps> = ({ email, loggedIn, token, setLoggedIn, setEmail,baseUrl,business, setBusiness }) => {
  const [userData, setUserData] = useState<{ Items: Array<{ email: string }> }>({ Items: [] });
  const [redemptionToken, setRedemptionToken] = useState<string>("");  // Initialize as an empty string
  const [loading, setLoading] = useState<boolean>(true); // Loading state
  const [businessInputValue, setBusinessInputValue] = useState<string>('');
  const [partnerInputValue, setPartnerInputValue] = useState<string>('');
  const [redemptionTokenInputValue, setRedemptionTokenInputValue] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [partner, setPartner] = useState<string>('par_11W5bdGHkTW1QGbW');

  


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Set loading to true before fetching
      try {
        const response = await fetch(baseUrl + 'redemptionToken?business_id=' + business, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'jwt-token': token,
          },
        });

        const data = await response.json();
        console.log(data);

        if (data.token) {
          setRedemptionToken(data.token); // Update state with fetched data
          console.error("Redemption Token set");
          setErrorMessage("");
        } else {
          console.error(data);

          if(data.message) {
            setErrorMessage("An error occurred:" + data.message);
          }
          else{
            setErrorMessage("An error occurred");
          }
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    fetchData(); // Call the fetchData function
  }, [token, business]); // Dependency array: re-fetch only if token changes

 
  // Function to handle input change with explicit typing
  const handleBusinessInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBusinessInputValue(event.target.value);
  };

  // Function to handle input change with explicit typing
  const handlePartnerInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPartnerInputValue(event.target.value);
  };

  // Function to handle input change with explicit typing
  const handleRedemptionTokenInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRedemptionTokenInputValue(event.target.value);
  };


  // Function to handle button click
  const handleButtonClick = () => {
    if(businessInputValue) {
    setBusiness(businessInputValue);
    setBusinessInputValue(''); // Optionally clear the input field after setting the state 
    }
    
    if(partnerInputValue){
      setPartner(partnerInputValue);
      setPartnerInputValue(''); // Optionally clear the input field after setting the state 
    }

    if(redemptionTokenInputValue){
      setRedemptionToken(redemptionTokenInputValue);
      setRedemptionTokenInputValue(''); // Optionally clear the input field after setting the state 
    }
  };




  return (
    <>
    <div className={'pipe-container'}>
      <div className={'right-aligned-div'}>
      <br />
      <input
        type="text"
        value={businessInputValue}
        onChange={handleBusinessInputChange}
        placeholder="Enter business id"
        className="inputBox"/>
      <input
        type="text"
        value={partnerInputValue}
        onChange={handlePartnerInputChange}
        placeholder="Enter partner id"
        className="inputBox"/>
            <input
        type="text"
        value={redemptionTokenInputValue}
        onChange={handleRedemptionTokenInputChange}
        placeholder="Enter redemption token"
        className="inputBox"/>
      <input className="inputButton" type="button" onClick={handleButtonClick} value="Update" /><br />
      {errorMessage}
      </div>
      <br /><br />
      <button 
        onClick={() => {
          const url = `https://app.pipe-sandbox.com/partner/${encodeURIComponent(partner)}/redeem?token=${encodeURIComponent(redemptionToken)}`;
          window.open(url, '_blank', 'noopener,noreferrer');
        }} 
        className="linkButton"
      >
        Go to Hosted Page
      </button>
      
      <br />
  

    </div>
    
    </>
  );
};

export default Hosted;
